import { fetch, update } from 'app/utils/data'
import { default as deserialize } from 'app/utils/deserialize'

function detailFrom(error, fallback) {
  const errors = error && error.response && error.response.data && error.response.data.errors

  return Array.isArray(errors) && errors.length && errors[0].detail ? errors[0].detail : fallback
}

export default {
  namespaced: true,

  state: {
    list: []
  },

  getters: {
    platformLicenses: (state) => state.list
  },

  mutations: {
    setPlatformLicenses(state, licenses) {
      state.list = licenses
    },

    replacePlatformLicense(state, license) {
      state.list = state.list.map((existing) => (existing.id === license.id ? license : existing))
    }
  },

  actions: {
    async fetchPlatformLicenses({ commit }) {
      const response = await fetch({ url: '/api/admin/platform-licenses' })

      commit('setPlatformLicenses', await deserialize(response.data))
    },

    async fetchAccountPlatformLicenses(_context, accountId) {
      const response = await fetch({ url: '/api/admin/platform-licenses', params: { account_id: accountId } })

      return deserialize(response.data)
    },

    async endPlatformLicense({ commit }, { id, note }) {
      try {
        const response = await update({
          url: `/api/admin/platform-licenses/${id}`,
          type: 'platform-license',
          patch: true,
          record: { id },
          changes: { state: 'ended', endNote: note }
        })

        const license = await deserialize(response.data)

        commit('replacePlatformLicense', license)

        return license
      } catch (error) {
        throw new Error(detailFrom(error, 'That license could not be ended.'))
      }
    },

    async activatePlatformLicense({ commit }, { id, note, paidOn }) {
      try {
        const response = await update({
          url: `/api/admin/platform-licenses/${id}`,
          type: 'platform-license',
          patch: true,
          record: { id },
          changes: { state: 'active', activationNote: note, termStartedOn: paidOn }
        })

        const license = await deserialize(response.data)

        commit('replacePlatformLicense', license)

        return license
      } catch (error) {
        throw new Error(detailFrom(error, 'That license could not be activated.'))
      }
    }
  }
}
